import React from 'react';
import { Box, Typography, Card, CardContent, Button, Chip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PsychologyIcon from '@mui/icons-material/Psychology';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { flowLogger } from '../../utils/flowLogger';

const PathSelectionStep = ({ kid, onSelectPedagogical, onSelectNeuro }) => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#FFF7E5',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: { xs: 'flex-start', sm: 'center' },
        px: 2,
        pt: { xs: 3, sm: 4 },
        pb: 4,
      }}
    >
      <Typography variant="h5" sx={{ color: '#784e3c', fontWeight: 700, mb: 1, textAlign: 'center' }}>
        Choisissez votre parcours
      </Typography>
      <Typography sx={{ color: '#666', mb: 4, textAlign: 'center', maxWidth: 420 }}>
        Pour {kid?.firstname || 'votre enfant'}, vous pouvez compléter le profil pédagogique, le profil Neuro, ou les deux à votre rythme.
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%', maxWidth: 420 }}>
        <Card
          sx={{ cursor: 'pointer', border: '2px solid transparent', '&:hover': { borderColor: '#784e3c' } }}
          onClick={() => {
            flowLogger('profiling.path.pedagogical', { kidId: kid?.id });
            onSelectPedagogical();
          }}
        >
          <CardContent sx={{ display: 'flex', gap: 2, alignItems: 'center', py: 3 }}>
            <MenuBookIcon sx={{ fontSize: 48, color: '#784e3c' }} />
            <Box>
              <Typography variant="h6" sx={{ color: '#784e3c' }}>Profil pédagogique</Typography>
              <Typography variant="body2" color="text.secondary">
                Questions classiques pour découvrir le style d&apos;apprentissage
              </Typography>
            </Box>
          </CardContent>
        </Card>

        <Card
          sx={{ cursor: 'pointer', border: '2px solid transparent', '&:hover': { borderColor: '#784e3c' } }}
          onClick={() => {
            flowLogger('profiling.path.neuro', { kidId: kid?.id });
            onSelectNeuro();
          }}
        >
          <CardContent sx={{ display: 'flex', gap: 2, alignItems: 'center', py: 3 }}>
            <PsychologyIcon sx={{ fontSize: 48, color: '#784e3c' }} />
            <Box sx={{ flex: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', mb: 0.5 }}>
                <Typography variant="h6" sx={{ color: '#784e3c' }}>Profil Neuroatypique</Typography>
                <Chip
                  label="Nouveau"
                  size="small"
                  sx={{
                    height: 22,
                    fontSize: '0.7rem',
                    fontWeight: 700,
                    bgcolor: '#FFD88C',
                    color: '#5a3d2b',
                  }}
                />
              </Box>
              <Typography variant="body2" color="text.secondary">
                15 questions rapides — orientation bienveillante, sans diagnostic médical
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Box>

      <Button
        type="button"
        sx={{ mt: 4, color: '#784e3c' }}
        onClick={() => navigate('/HomePage')}
      >
        Retour
      </Button>
    </Box>
  );
};

export default PathSelectionStep;
